'use client';

import { BookDemoButton } from '@/components/ui';
import IndustryHero from '@/components/industry/IndustryHero';
import IndustryCommandCentre from '@/components/industry/IndustryCommandCentre';
import { useTranslation } from '@/hooks/useTranslation';

const BLUE = { color: 'var(--brand)' };
const DEEP = { color: 'var(--brand-deep)' };

/* Sector command-centre data — Government citizen grievance operations.
   Sample/mock dashboard content (not marketing copy). */
const CC = {
  pulseTitle: 'Citizen grievance pulse',
  kpis: [
    { val: '1,870', lbl: 'Live mentions', live: true },
    { val: '150', lbl: 'Open grievances' },
    { val: '5.2m', lbl: 'Avg. first response' },
  ],
  sentiment: [
    { lbl: 'Positive', pct: 33, tone: 'positive' },
    { lbl: 'Neutral', pct: 35, tone: 'neutral' },
    { lbl: 'Negative', pct: 32, tone: 'negative' },
  ],
  sla: { pct: 71, lbl: 'SLA met' },
  tickerLabel: 'Incoming grievances',
  tickerItems: [
    { letter: 'R', text: 'Scheme benefit not credited', handle: '@ramesh_y', tag: 'Scheme', tagLevel: 'high' },
    { letter: 'S', text: 'Certificate pending for weeks', handle: '@sunita_d', tag: 'Document', tagLevel: 'med' },
    { letter: 'M', text: 'Portal down, cannot apply', handle: '@manoj_k', tag: 'Service', tagLevel: 'med' },
    { letter: 'A', text: 'No response from department', handle: '@anita_p', tag: 'Escalation', tagLevel: 'high' },
  ],
  chips: [
    { variant: 'light', title: 'Escalation risk', sub: 'Grievances nearing SLA breach' },
    { variant: 'dark', title: 'AgentIQ routed', sub: 'Case → dept officer in 2s' },
  ],
};

export default function GovernmentHero() {
  const { t } = useTranslation();

  return (
    <IndustryHero
      layout="visual"
      breadcrumb={{
        ariaLabel: t('breadcrumb.breadcrumb'),
        label: t('footer.col.industries'),
        href: '/industries',
        current: t('Government & Public Sector'),
      }}
      title={
        <>
          {t('industries_government_public_sector.citizens_are_talking_is_your_govern')}{' '}
          <span className="serif-accent italic">{t('industries_government_public_sector.government_citizen_experience_platf')}</span>
          {' '}{t('industries_government_public_sector.for')}{' '}
          <span className="serif-accent italic">{t('industries_government_public_sector.departments_public_bodies_smart_cit')}</span>.
        </>
      }
      lead={
        <>
          {t('industries_government_public_sector.when_a_public_service_fails_citizen')}{' '}
          <span style={BLUE}>{t('industries_government_public_sector.misinformation')}</span> {t('industries_government_public_sector.fills_the_gap_before_an_official_re')}{' '}
          <span style={DEEP}>{t('industries_government_public_sector.locobuzz_closes_that_gap')}</span>
        </>
      }
      actions={
        <BookDemoButton label={t('industries_government_public_sector.book_a_personalised_government_publ')} />
      }
      visual={<IndustryCommandCentre ariaLabel="Government citizen grievance command centre" {...CC} />}
    />
  );
}
